
const LOGIN_LOGO = "../../../assets/img/login_logo.png"
const SIDEBAR_LOGO = "../../../../assets/img/login_logo.png"
const PROFILE_IMG = "../../../assets/img/avatar/avatar-4.png"
const DUMMY_IMG = "../../../assets/img/avatar/avatar-4.png"
const PRODUCT_IMG = "../../../assets/img/news/img14.jpg"

export {LOGIN_LOGO, SIDEBAR_LOGO, PROFILE_IMG, DUMMY_IMG, PRODUCT_IMG};